export const AI_PROCESSING_ASSET_TYPES = {
  AUDIT: 'AUDIT',
  TRACING: 'TRACING',
  CERTIFICATE: 'CERTIFICATE',
  CERTIFIED_MATERIALS: 'CERTIFIED_MATERIALS',
  CAP: 'CAP',
  COMPANY_DOCUMENTS: 'COMPANY_DOCUMENTS',
} as const;

export type AiProcessingAssetType =
  (typeof AI_PROCESSING_ASSET_TYPES)[keyof typeof AI_PROCESSING_ASSET_TYPES];

export const AI_PROCESSING_STATUSES = {
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  DISMISSED: 'DISMISSED',
} as const;

export type AiProcessingStatus =
  (typeof AI_PROCESSING_STATUSES)[keyof typeof AI_PROCESSING_STATUSES];

/**
 * Why a row left the queue. Stored in `metadata.resolution.reason` and on the
 * job's `entity_history` entry, next to the unchanged `status = 'DISMISSED'` /
 * `dismissed_at` pair every reader already filters on.
 */
export const AI_PROCESSING_RESOLUTION_REASONS = {
  /** The request that used the result (certificate / audit created) closed it. */
  CONSUMED: 'CONSUMED',
  /** The user removed the card from the queue. */
  USER_DISMISSED: 'USER_DISMISSED',
  /** The workflow behind it was cancelled. */
  CANCELLED: 'CANCELLED',
  /** Waiting for a human past the self-heal cron's cutoff with no activity. */
  EXPIRED: 'EXPIRED',
  /** The self-heal cron found its result already used and closed the leak. */
  SELF_HEALED: 'SELF_HEALED',
} as const;

export type AiProcessingResolutionReason =
  (typeof AI_PROCESSING_RESOLUTION_REASONS)[keyof typeof AI_PROCESSING_RESOLUTION_REASONS];

/**
 * Resolutions the platform made on its own, as opposed to a user dismissing or
 * cancelling. Only these reopen when new work lands on the same asset (a CAPA
 * workflow gaining findings steps after its audit was created): a card the user
 * removed stays removed, exactly as before.
 */
export const AI_PROCESSING_REOPENABLE_RESOLUTION_REASONS: readonly AiProcessingResolutionReason[] =
  [
    AI_PROCESSING_RESOLUTION_REASONS.CONSUMED,
    AI_PROCESSING_RESOLUTION_REASONS.EXPIRED,
    AI_PROCESSING_RESOLUTION_REASONS.SELF_HEALED,
  ];
